import lazyLoading from "./lazyLoading";

const memberQuestionsMeta = {
  viewTitle: "My Questions",
  menuIcon: "questions",
  auth: true
};
export const memberQuestionsRoutes = {
  path: "/member-questions",
  name: "MemberQuestions",
  redirect: "/member-questions/unanswered",
  component: lazyLoading("MemberQuestions"),
  meta: {
    ...memberQuestionsMeta
  },
  children: [
    {
      path: "unanswered",
      name: "MemberQuestionsUnanswered",
      meta: {
        ...memberQuestionsMeta
      },
      component: lazyLoading("MemberQuestionsUnanswered")
    },
    {
      path: "answered",
      name: "MemberQuestionsAnswered",
      meta: {
        ...memberQuestionsMeta
      },
      component: lazyLoading("MemberQuestionsAnswered")
    }
  ]
};

export default memberQuestionsRoutes;
